import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeUserFromOrg = async ({
  userId,
  orgId,
}: {
  userId: string;
  orgId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(`${orgId}/users/${userId}`);
  return response.data;
};

export function useRemoveUserFromOrg(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { userId: string; orgId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ userId, orgId }) => removeUserFromOrg({ userId, orgId }),
    ...queryOptions,
  });
}
